import { audiogramSchema } from '@mi-front/audiogram';
import { z } from 'zod';

export const audiogramStyleSchema = audiogramSchema.pick({
  titleColor: true,
  backgroundType: true,
  backgroundColor: true,
  backgroundImageUrl: true,
  captionsTextColor: true,
  visualizerColor: true,
});

export type MessageFormatter = (msg: { id: string; defaultMessage: string }) => string;

const requiredMsg = { id: 'common.required', defaultMessage: 'Requerido' };
const atLeastOneFormatMsg = {
  id: 'audiogram.validation.atLeastOneFormat',
  defaultMessage: 'At least one format is required',
};
const atLeastOneDefaultTemplateMsg = {
  id: 'audiogram.validation.atLeastOneDefaultTemplate',
  defaultMessage: 'At least one template must be marked as default',
};

export function getSchema(t: MessageFormatter) {
  return z.object({
    station: z.object({
      id: z.string(),
      name: z.string(),
      logoUrl: z.string(),
    }),
    templates: z
      .array(
        z.object({
          name: z.string().min(1, t(requiredMsg)),
          default: z.boolean(),
          data: audiogramStyleSchema.extend({
            variants: z.array(z.string()).min(1, t(atLeastOneFormatMsg)),
          }),
        }),
      )
      .refine((templates) => !templates.length || templates.some((template) => template.default), {
        message: t(atLeastOneDefaultTemplateMsg),
        path: ['root'],
      }),
  });
}

/** @deprecated Use getSchema(t) for translated messages */
export const schema = getSchema((msg) => msg.defaultMessage);

export type FormValues = z.infer<ReturnType<typeof getSchema>>;

export const defaultValues: FormValues = {
  station: {
    id: '',
    name: '',
    logoUrl: '',
  },
  templates: [],
};
